export class userToAdd {
  firstName = "";
  lastName = "";
  userName = "";
  password = "";
  email = "";
  position = "";
  phoneNumber = "";
}
